import React, { useState } from "react";
import { ArrowLeft, Layers, FileText, Tag } from "lucide-react";
import ManageReportHeader from "../../pages/MangageReport/ManageReportHeader";  
import Tabs from "../Tabs/Tabs";
import Button from "../Button/Button";
import "./TemplateDetailView.css";

const ALL_TABS = [
  { id: "question_parameter", key: "question_parameter", label: "Question Parameters", icon: <Layers size={16} /> },
  { id: "report", key: "report", label: "Report Headers", icon: <FileText size={16} /> },
  { id: "keywords", key: "keywords", label: "Product Keywords", icon: <Tag size={16} /> },
];

const TemplateDetailView = ({
  selectedTemplate,
  handleBack,
  handleSaveChanges,
  onAddSection,
  children, 
}) => {
  const [activeTab, setActiveTab] = useState("question_parameter");

  const visibleTabs = ALL_TABS.filter((tab) => {
    if (tab.key === "question_parameter") return true;
    if (tab.key === "report") return selectedTemplate?.report_header !== false;
    if (tab.key === "keywords") return selectedTemplate?.transcription_accuracy === true; // show only if enabled
    return true;
  });

  return (
    <div className="template-detail-view">
      {/* Header */}
      <div className="tdv-header">
        <div className="tdv-header-left">
           <ArrowLeft size={18} onClick={handleBack} />
          <h5 className="template-title">
            Audit Template ({selectedTemplate.name})
          </h5>
        </div>
        <div className="tdv-header-right">
          {activeTab === "question_parameter" && (
            <Button variant="success" onClick={handleSaveChanges}>
              {selectedTemplate.id ? "Save Changes" : "Save as My Template"}
            </Button>
          )}
        </div>
      </div>

      {/* Tabs */}
      <Tabs
        tabs={visibleTabs}
        activeTab={activeTab}
        onChange={setActiveTab}
        onTabChange={setActiveTab}
      />

      {/* Tab Content */}
      <div className="tdv-content" style={{ marginTop: 10 }}>
        {activeTab === "question_parameter" && (
          <div className="tdv-question_parameter">{children}</div>
        )}

        {activeTab === "report" && (
          <ManageReportHeader
            selectedTemplate={selectedTemplate}
            handleBack={() => setActiveTab("question_parameter")}
            hideHeader={true}
          />
        )}
      </div>
    </div>
  );
};

export default TemplateDetailView;
